export type Language = 'en' | 'es' | 'ca' | 'ru';

export const LANGUAGES: { code: Language; name: string }[] = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Español' },
    { code: 'ca', name: 'Català' },
    { code: 'ru', name: 'Русский' }
];
